import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LayoutUtilsService } from 'src/app/core/layout-utils.service';
import { AuthService } from 'src/app/modules/auth/_services/auth.service';
import { Artikel } from '../../store/models/artikel';
import { Warenkorb } from '../../store/models/warenkorb';
import { Webshops } from '../../store/models/webshops';
import { WarenkorbsService } from '../../webshops/warenkorbs/shared/warenkorbs.service';
import { ArtikelQuickView1Component } from '../artikel-quick-view1/artikel-quick-view1.component';
import { ArtikelsService } from '../shared/artikels.service';

class SelectedArtikel {
    // artikelId: number;
    // isMatrixArtikel: boolean = false;
    artikel: any;
    menge: number;
    farbe: Artikel.IArtikelListSettingFarbenDto;
    groesse: Artikel.IArtikelListSettingGroessenDto;
    isMatrixArtikel: boolean;
    selectedKurs: any;
}


@Component({
    selector: 'kkis-app-artikel-list1',
    templateUrl: './artikel-list1.component.html',
    styleUrls: ['./artikel-list1.component.scss']
})
export class ArtikelList1Component implements OnInit, OnChanges {

    // ViewChild
    @ViewChild(MatPaginator)
    paginator = {} as MatPaginator;

    // Input
    @Input()
    search: string;

    @Input()
    category: string;

    @Input()
    minPreisFilter: number;

    @Input()
    maxPreisFilter: number;

    @Input()
    filterGroessen: string;

    @Input()
    filterFarben: string;

    @Input()
    filterMerkmale: string;

    @Input()
    nurAufLager: boolean = false;


    // Output
    @Output()
    minPreis: EventEmitter<number> = new EventEmitter<number>();

    @Output()
    maxPreis: EventEmitter<number> = new EventEmitter<number>();

    @Output()
    groessen: EventEmitter<Artikel.IArtikelListSettingGroessenDto[]> = new EventEmitter<Artikel.IArtikelListSettingGroessenDto[]>();

    @Output()
    farben: EventEmitter<Artikel.IArtikelListSettingFarbenDto[]> = new EventEmitter<Artikel.IArtikelListSettingFarbenDto[]>();

    @Output()
    numberWarenkorbItems: EventEmitter<number> = new EventEmitter<number>();

    @Output()
    merkmalGruppen: EventEmitter<Artikel.IMerkmalGruppeDto[]> = new EventEmitter<Artikel.IMerkmalGruppeDto[]>();

    // User
    loggedInUser: Webshops.ILoggedInUser;


    // colClass for different number of columns
    colClass = "col-3";
    itemsPerRow: number;
    itemsPerRowMax: number;

    // Warenkorb
    warenkorb: Warenkorb.IWarenkorbDto;

    // Artikel
    artikel: Artikel.IArtikelDto[];
    artikeloptions: Artikel.IArtikelOptionsDto;   

    // Paging
    page: number = 0;
    pageSize: number = 25;
    maxItems: number = 0;
    previousPage: any;
    pageSizeOptions: number[] = [5, 10, 25, 50, 100];

    // // FormGroups
    searchTerm: string = "";
    sortField: string = "nr";
    sortDirection: string = "asc";
    sortIcon: string;
    sortIconText: string;

    // Filter
    filterString: string = "";

    // Images (from Database)
    imgFile: BlobPart[];
    imgMatrixFile: BlobPart[];
    // (from local <<NOT>> FROM DATABASE)
    imgDummy: string = "assets/media/svg/files/no-image.svg";

    // Dialog
    dialogWidth: string;
    dialogHeight: string;

    // Utils
    isLoading: boolean = true;
    isSubmitted: boolean = false;
    isFiltered: boolean = false;
    isList: boolean = false;
    isLoggedIn: boolean = false;
    articlesfound: boolean = false;

    // Artikeloptionen
    display_artnr: boolean = false;
    display_herstellernr: boolean = false;
    display_mcode1: boolean = false;
    display_mcode2: boolean = false;
    lbl_mcode1: string;
    lbl_mcode2: string;

    constructor(
        public dialog: MatDialog,
        private _snackBar: MatSnackBar,
        private layoutUtilsService: LayoutUtilsService,
        private authService: AuthService,
        private artikelsService: ArtikelsService,
        private warenkorbsService: WarenkorbsService,
    ) { }

    ngOnInit(): void {
        var w = this.layoutUtilsService.getBootstrapClass();
        switch(w) {
            case 0:
            case 1: {
                this.dialogWidth = "95%";
                this.dialogHeight = "95%";
                this.itemsPerRowMax = 1;
                this.onSelectListNumberColumns(1);
                break;
            }
            case 2: {
                this.dialogWidth = "80%";
                this.dialogHeight = "70%";
                this.itemsPerRowMax = 2;
                this.onSelectListNumberColumns(2);
                break;
            }
            case 3: {
                this.dialogWidth = "80%";
                this.dialogHeight = "70%";
                this.itemsPerRowMax = 4;
                this.onSelectListNumberColumns(4);
                break;
            }
            default: {
                this.dialogWidth = "80%";
                this.dialogHeight = "70%";
                this.itemsPerRowMax = 6;
                this.onSelectListNumberColumns(4);
                break;
            }
        }

        this.authService.isAuthenticated$.subscribe(x => {
            this.isLoggedIn = x;
        });
    }

    ngOnChanges(changes: SimpleChanges): void {

        if (changes.search != null && changes.search.currentValue != "" && changes.search.previousValue != changes.search.currentValue) {
            this.search = changes.search.currentValue;
        }

        if (changes.category != null && changes.category.currentValue != "" && changes.category.previousValue != changes.category.currentValue) {
            this.category = changes.category.currentValue;
        }

        if (changes.minPreis != null && changes.minPreis.currentValue != null && changes.minPreis.previousValue != changes.minPreis.currentValue) {
            this.minPreisFilter = changes.minPreis.currentValue;
        }

        if (changes.maxPreis != null && changes.maxPreis.currentValue != null && changes.maxPreis.previousValue != changes.maxPreis.currentValue) {
            this.maxPreisFilter = changes.maxPreis.currentValue;
        }

        if (changes.filterGroessen != null && changes.filterGroessen.currentValue != null && changes.filterGroessen.previousValue != changes.filterGroessen.currentValue) {
            this.filterGroessen = changes.filterGroessen.currentValue;
        }

        if (changes.filterFarben != null && changes.filterFarben.currentValue != null && changes.filterFarben.previousValue != changes.filterFarben.currentValue) {
            this.filterFarben = changes.filterFarben.currentValue;
        }

        if (changes.filterMerkmale != null && changes.filterMerkmale.currentValue != null && changes.filterMerkmale.previousValue != changes.filterMerkmale.currentValue) {
            this.filterMerkmale = changes.filterMerkmale.currentValue;
        }

        if (changes.nurAufLager != null && changes.nurAufLager.currentValue != null && changes.nurAufLager.currentValue != changes.nurAufLager.previousValue) {
            this.nurAufLager = changes.nurAufLager.currentValue;
        }

        this.loadPage(0);
    }

    getData(event) {
        if (this.pageSize != event.pageSize) {
            this.pageSize = event.pageSize;
        }
        this.loadPage(event.pageIndex);
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
        }

        this.loadData(page, this.sortField, this.sortDirection);

        if (page === 0) {
            this.paginator.pageIndex = 0;
        }

    }

    loadData(page: number, sortField: string = 'nr', sortDirection: string = 'asc') {

        this.isLoading = true;

        console.log("call-artservice.getlistfilter => ", new Date());

        this.artikelsService.getListFilter(
            page, 
            this.pageSize, 
            sortField, 
            sortDirection, 
            this.category, 
            this.minPreisFilter, 
            this.maxPreisFilter, 
            this.filterGroessen, 
            this.filterFarben,
            this.filterMerkmale, 
            this.search,
            this.nurAufLager).subscribe(res => {

                console.log("after call-artservice.getlistfilter => ", new Date());
                console.log("getlistfilter => ", res);


                if (res.artikelList) {
                    this.artikel = res.artikelList.items;
                    this.maxItems = res.artikelList.totalCount;

                    //console.log("getlistfilter.res => ", new Date());
                    
                    this.minPreis.emit(res.artikelListSettings.minPreis);
                    this.maxPreis.emit(res.artikelListSettings.maxPreis);
    
                    this.groessen.emit(res.artikelListSettings.groessen);
                    this.farben.emit(res.artikelListSettings.farben);
    
                    this.merkmalGruppen.emit(res.merkmalGruppenList);

                    this.isLoading = false;

                } else {

                    this.isLoading = false;
   
                }

                this.articlesfound = (this.maxItems == 0 ? false : true);
                //console.log("Keine Artikel zur Suche gefunden!");
                //console.log("Artikel gefunden: "+this.articlesfound)

                //ArtikelOptionen
                this.display_artnr = res.artikelOptions.display_artnr;
                this.display_herstellernr = res.artikelOptions.display_herstellernr;
                this.display_mcode1 = res.artikelOptions.display_mcode1;
                this.display_mcode2 = res.artikelOptions.display_mcode2;
                this.lbl_mcode1 = res.artikelOptions.lbl_mcode1;
                this.lbl_mcode2 = res.artikelOptions.lbl_mcode2;

                this.artikeloptions = res.artikelOptions;
            });

        this.setSortierText(sortField, sortDirection);        

    }

    resetPage() {
        this.paginator.firstPage();
    }

    onSelectListStyle(style: number) {
        if (style == 0) {
            this.isList = false;
        } else if (style == 1) {
            this.isList = true;
        }
    }

    onSelectListNumberColumns(nCol: number) {
        if (nCol == 1) {
            this.colClass = "col-12";
        } else if (nCol == 2) {
            this.colClass = "col-6";
        } else if (nCol == 3) {
            this.colClass = "col-4";
        } else if (nCol == 4) {
            this.colClass = "col-3";
        } else if (nCol == 6) {
            this.colClass = "col-2";
        }

        this.itemsPerRow = nCol;
    }

    onSorting(sField: string, sDirection: string) {
        this.sortField = sField;
        this.sortDirection = sDirection;

        this.loadData(0, sField, sDirection);
    }

    onOpenArtikelQuickView(artikel: Artikel.IArtikelDto) {

        const dialogRef = this.dialog.open(ArtikelQuickView1Component, {
            width: this.dialogWidth,
            disableClose: true,
            autoFocus: true,
            data: {
                artikel: artikel,
                artikeloptions: this.artikeloptions
            }
        });

        dialogRef.afterClosed().subscribe((res: SelectedArtikel) => {
            console.log("dialogRef.afterClosed --> add to warenkorb: "+res.selectedKurs);

            // add to warenkorb if menge > 0
            if (res.menge > 0) {
                this.onAddToWarenkorb(res.artikel, res.menge, res.isMatrixArtikel, res.selectedKurs)
            }
        });
    }

    onOpenArtikelDetailView(artikel: Artikel.IArtikelDto) {
    }

    onAddToWarenkorb(artikel, menge: number, isMatrixArtikel: boolean = false, selectedKurs = null) {
        if (this.isLoggedIn) {
            this.isSubmitted = true;

            let newPosition = {} as Warenkorb.IAddPositionDto;
    
            newPosition.artikelKennung = artikel.id;
            newPosition.menge = menge;
            newPosition.isMatrixArtikel = isMatrixArtikel;

            if (selectedKurs != null) {
                //gebuchte Kurse in die entsprechenden Tabellen buchen und mit der Position verknüpfen
                newPosition.notiz = 'Kursteilnehmer: ';
                for (let i = 0; i <= selectedKurs.teilnehmer.length-1; i++) {
                    newPosition.notiz += (i == 0 ? '' :', ') + selectedKurs.teilnehmer[i];
                }

                newPosition.kurs = selectedKurs;
                
            }
    
            this.warenkorbsService.addPosition(newPosition).subscribe(res => {
                if (res != null) {
                    this.numberWarenkorbItems.emit(res.warenkorbPositionen.length);
                }       
            });

        } else {
            const _title: string = "Anmelden";
            const _description: string = "Sie sind noch nicht angemeldet. Jetzt anmelden?";
    
            this.layoutUtilsService.qwertDialog(_title, _description, 'question', true, true, 'Anmelden').then(res => {
                if (res.dismiss) {
                    return;
                }

                this.authService.login();
                return;

            });
        }
    }

    setSortierText(sortField, sortDirection) {
        
        if (sortField == 'nr' && sortDirection == 'asc') {
            this.sortIcon = 'fas fa-sort-numeric-down';
            this.sortIconText = 'Artikelnummer aufsteigend';
        } else if (sortField == 'nr' && sortDirection == 'desc') {
            this.sortIcon = 'fas fa-sort-numeric-up';
            this.sortIconText = 'Artikelnummer absteigend';
        } else if (sortField == 'name' && sortDirection == 'asc') {
            this.sortIcon = 'fas fa-sort-alpha-down';
            this.sortIconText = 'Produktname aufsteigend';
        } else if (sortField == 'name' && sortDirection == 'desc') {
            this.sortIcon = 'fas fa-sort-alpha-up';
            this.sortIconText = 'Produktname absteigend';
        } else if (sortField == 'vkpreis' && sortDirection == 'asc') {
            this.sortIcon = 'fas fa-sort-numeric-down';
            this.sortIconText = 'Preis aufsteigend';
        } else if (sortField == 'vkpreis' && sortDirection == 'desc') {
            this.sortIcon = 'fas fa-sort-numeric-up';
            this.sortIconText = 'Preis absteigend';
        }
    }
}
